import { motion } from "framer-motion";
import { useLanguage } from "@/i18n";

const LOGOS = [
  { src: "/clients/manresa.png", alt: "Ajuntament de Manresa" },
  { src: "/clients/granland.png", alt: "Granland" },
  { src: "/clients/pajarraco.png", alt: "Pajarraco" },
  { src: "/clients/publicis.png", alt: "Publicis España" },
  { src: "/clients/wildstories.png", alt: "Wild Stories" },
  { src: "/clients/wowist.png", alt: "WOWist" },
];

export const ClientsSection = () => {
  const { t } = useLanguage();

  return (
    <section
      className="relative w-full bg-background py-20 lg:py-28 overflow-hidden"
      data-testid="clients-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-12">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.4, 0, 0.2, 1] }}
          className="font-serif text-2xl lg:text-3xl font-light text-foreground tracking-wide text-center mb-14 lg:mb-20"
          data-testid="clients-title"
        >
          {t.home.clientsTitle}
        </motion.h2>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, delay: 0.15, ease: [0.4, 0, 0.2, 1] }}
          className="flex flex-wrap items-center justify-center gap-y-12 gap-x-8 sm:gap-x-14 lg:gap-x-16"
        >
          {LOGOS.map((logo, i) => (
            <div
              key={logo.alt}
              className="flex items-center justify-center basis-[42%] sm:basis-[26%] lg:basis-auto"
              data-testid={`client-logo-${i}`}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                loading="lazy"
                className="h-10 sm:h-11 lg:h-12 w-auto max-w-[150px] object-contain opacity-60 hover:opacity-100 transition-opacity duration-500"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
